import SuccessIntegrationScreen from "./SuccessIntegrationScreen";


export default SuccessIntegrationScreen;